import React from 'react';
import { Route } from 'react-router';
import * as Screens from '../screens';
import { matingRoutePaths } from './route-paths';

/** Public router entries for the mating feature screens. */
export const matingRoutes = [<Route path={matingRoutePaths.mating} element={<Screens.Mating />} key="mating" />, <Route path={matingRoutePaths.bullSelectorH} element={<Screens.BullSelectorH />} key="bullselectorH" />, <Route path={matingRoutePaths.bullSelectorC} element={<Screens.BullSelectorC />} key="bullselectorC" />];